import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { i18n } from './i18n'
import App from './App.vue'
import './index.css'
import 'flag-icons/css/flag-icons.min.css';
import router from './router'
import axios from 'axios'
import { createHead } from '@vueuse/head'

axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL

const app = createApp(App)
const head = createHead()
app.use(head)
app.use(createPinia())
app.use(router)
app.use(i18n)
app.mount('#app')
